<template>
  <div>
    <v-card class="overflow-hidden ma-5">
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              :label="$t('transfer_order_number')"
              v-model="filterTransferOrder.Number"
              @input="getTransferOrder"
            ></v-text-field>
          </v-col>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterTransferOrder"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterTransferOrder.LicensePlate"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getTransferOrder">
              {{ $t('common_search') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="transferOrderDataTableHeaders"
      :items="transferOrderList"
      :search="searchTransferOrder"
      class="elevation-1 ma-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoadingTransferOrder"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchTransferOrder"
            append-icon="mdi-magnify"
            :label="$t('common_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-dialog v-model="isShowEditedTransferOrderDialog" fullscreen persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('common_edit') }}</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Number"
                    :label="$t('transfer_order_order_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.Number"
                    :label="$t('transfer_order_customer_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.ShortName"
                    :label="$t('transfer_order_customer_short_name')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.Customer.FullName"
                    :label="$t('transfer_order_customer_full_name')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.LicensePlateList"
                    :label="$t('transfer_order_license_plate')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.ItemAmt"
                    :label="$t('transfer_order_original_amount')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.NewItemAmt"
                    :label="$t('transfer_order_modified_amount')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.QuotationNumber"
                    :label="$t('transfer_order_original_quotation_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.NewQuotationNumber"
                    :label="$t('transfer_order_new_quotation_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.ErpTransferOrderNumber"
                    :label="$t('transfer_order_erp_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedTransferOrder.InvalidReason"
                    :label="$t('transfer_order_invalid_reason')"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row> </v-row>
              <v-row>
                <v-col cols="6">
                  <v-data-table
                    :headers="transferOrderOriginalItemDataTableHeaders"
                    :items="newTransferOrderItems"
                    :search="searchTransferOrderItem"
                    class="elevation-1 ma-5"
                    item-key="Index"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    :loading-text="$t('common_get_data')"
                    :footer-props="{
                      'items-per-page-options': [30, 50, 100],
                      'items-per-page-text': $t('item_rows_per_page'),
                    }"
                    :header-props="headerProps"
                  >
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td v-if="item.NewQuotationItem && item.NewQuotationItem.Id">
                          {{ $t('transfer_order_modified') }}
                        </td>
                        <td v-else-if="item.OriginalQuotationItem.IsDelete">
                          {{ $t('transfer_order_deleted') }}
                        </td>
                        <td v-else>{{ $t('transfer_order_no_change') }}</td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Number }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Describe }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Name }}
                        </td>
                        <td class="text-start">
                          {{ item.OriginalQuotationItem.Unit }}
                        </td>
                        <td class="text-end">
                          {{ item.OriginalQuotationItem.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ item.OriginalQuotationItem.TotalQuantity }}
                        </td>
                        <td v-if="item.OriginalQuotationItem.Number"></td>
                        <td v-if="!item.OriginalQuotationItem.Number" class="text-start">
                          <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                            mdi-chevron-up
                          </v-icon>
                          <v-icon @click="expand(!isExpanded)" v-else>
                            mdi-chevron-down
                          </v-icon>
                        </td>
                      </tr>
                    </template>

                    <template v-slot:expanded-item="{ item }">
                      <tr v-for="field in item.OriginalQuotationItem.BomItems" :key="field.Number">
                        <td></td>
                        <td class="text-start">
                          {{ field.Number }}
                        </td>
                        <td class="text-start">
                          {{ field.Describe }}
                        </td>
                        <td class="text-start">
                          {{ field.Name }}
                        </td>
                        <td class="text-start">
                          {{ field.Unit }}
                        </td>
                        <td class="text-end">
                          {{ field.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ field.TotalQuantity }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Before</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="searchTransferOrderItem"
                          append-icon="mdi-magnify"
                          :label="$t('common_search')"
                          single-line
                          hide-details
                          clearable
                        ></v-text-field>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="6">
                  <v-data-table
                    :headers="transferOrderNewItemDataTableHeaders"
                    :items="afterTransferOrderItems"
                    :search="searchTransferOrderItem"
                    class="elevation-1 ma-5"
                    item-key="Index"
                    :no-data-text="$t('common_no_data')"
                    :no-results-text="$t('common_no_results')"
                    :loading-text="$t('common_get_data')"
                    :footer-props="{
                      'items-per-page-options': [30, 50, 100],
                      'items-per-page-text': $t('item_rows_per_page'),
                    }"
                    :header-props="headerProps"
                  >
                    <template v-slot:item="{ item, expand, isExpanded }">
                      <tr>
                        <td
                          class="text-start"
                          v-if="item.OriginalQuotationItem && item.OriginalQuotationItem.Id"
                        ></td>
                        <td v-else>{{ $t('transfer_order_add') }}</td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Number }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Describe }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Name }}
                        </td>
                        <td class="text-start">
                          {{ item.NewQuotationItem.Unit }}
                        </td>
                        <td class="text-end">
                          {{ item.NewQuotationItem.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ item.NewQuotationItem.TotalQuantity }}
                        </td>
                        <td v-if="item.NewQuotationItem.Number"></td>
                        <td v-if="!item.NewQuotationItem.Number" class="text-start">
                          <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                            mdi-chevron-up
                          </v-icon>
                          <v-icon @click="expand(!isExpanded)" v-else>
                            mdi-chevron-down
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <tr v-for="field in item.NewQuotationItem.BomItems" :key="field.Number">
                        <td></td>
                        <td class="text-start">
                          {{ field.Number }}
                        </td>
                        <td class="text-start">
                          {{ field.Describe }}
                        </td>
                        <td class="text-start">
                          {{ field.Name }}
                        </td>
                        <td class="text-start">
                          {{ field.Unit }}
                        </td>
                        <td class="text-end">
                          {{ field.Quantity }}
                        </td>
                        <td class="text-end">
                          {{ field.TotalQuantity }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>After</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="searchTransferOrderItem"
                          append-icon="mdi-magnify"
                          :label="$t('common_search')"
                          single-line
                          hide-details
                          clearable
                        ></v-text-field>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closeEditedTransferOrderDialog">
                {{ $t('common_close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowTransferOrderDialogBtn(item)">
          <v-icon small> mdi-eye </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.LicensePlateList`]="{ item }">
        <div v-if="item.LicensePlateList.length > 2">
          <v-chip v-for="index in 2" :key="index" small>
            {{ item.LicensePlateList[index - 1] }}
          </v-chip>
          +({{ item.LicensePlateList.length - 2 }})
        </div>
        <div v-else>
          <v-chip v-for="licensePlate in item.LicensePlateList" :key="licensePlate" small>
            {{ licensePlate }}
          </v-chip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpTransferOrder } from '@/js/http-Manager'
import { TransferOrderStatus } from '@/js/TransferOrderStatus'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
export default {
  components: { CustomerAutocompleteFilter },
  name: 'DoneTransferOrder',
  props: {
    tabValue: {
      type: String
    }
  },
  data: () => ({
    transferOrderStatus: TransferOrderStatus,
    searchTransferOrderItem: '',
    isAllTextFieldDisabled: false,
    isLoadingTransferOrder: false,
    transferOrderList: [],
    searchTransferOrder: '',
    filterTransferOrder: {
      CustomerId: '',
      LicensePlate: '',
      Number: ''
    },
    editedTransferOrderIndex: -1,
    editedTransferOrder: {
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationNumber: '',
      ErpTransferOrderNumber: '',
      NewQuotationNumber: '',
      ItemAmt: 0,
      NewItemAmt: 0,
      IsThrowErp: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      Status: 0,
      LicensePlateList: [],
      TransferOrderItems: []
    },
    defaultTransferOrder: {
      Number: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      QuotationNumber: '',
      ErpTransferOrderNumber: '',
      NewQuotationNumber: '',
      ItemAmt: 0,
      NewItemAmt: 0,
      IsThrowErp: false,
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      Status: 0,
      LicensePlateList: [],
      TransferOrderItems: []
    },
    isShowEditedTransferOrderDialog: false
  }),
  async mounted () {
    await this.getTransferOrder()
  },
  watch: {
    async tabValue () {
      if (this.tabValue === 'tab-3') {
        await this.getTransferOrder()
      }
    }
  },
  computed: {
    afterTransferOrderItems () {
      let array = []
      this.editedTransferOrder.TransferOrderItems.forEach((element, index) => {
        if (element.NewQuotationItem && element.NewQuotationItem.Id) {
          element.Index = index
          array.push(element)
        }
      })
      return array
    },
    newTransferOrderItems () {
      let array = []
      this.editedTransferOrder.TransferOrderItems.forEach((element, index) => {
        if (element.OriginalQuotationItem && element.OriginalQuotationItem.Id) {
          element.Index = index
          array.push(element)
        }
      })
      return array
    },
    transferOrderDataTableHeaders () {
      return [
        { text: this.$t('transfer_order_order_number'), value: 'Number' },
        { text: this.$t('transfer_order_customer_number'), value: 'Customer.Number' },
        { text: this.$t('transfer_order_customer_short_name'), value: 'Customer.ShortName' },
        { text: this.$t('transfer_order_customer_full_name'), value: 'Customer.FullName' },
        { text: this.$t('transfer_order_license_plate_list'), value: 'LicensePlateList' },
        { text: this.$t('transfer_order_quotation_original_amount'), value: 'ItemAmt' },
        { text: this.$t('transfer_order_quotation_modified_amount'), value: 'NewItemAmt' },
        { text: this.$t('transfer_order_invalid_reason'), value: 'InvalidReason' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    transferOrderOriginalItemDataTableHeaders () {
      return [
        {
          text: this.$t('transfer_order_delete_or_update'),
          align: 'start',
          value: 'IsDeleteOrUpdate'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'OriginalQuotationItem.Number'
        },
        {
          text: this.$t('transfer_order_describe'),
          align: 'start',
          value: 'OriginalQuotationItem.Describe'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'OriginalQuotationItem.Name'
        },
        {
          text: this.$t('quotation_item_unit'),
          align: 'start',
          value: 'OriginalQuotationItem.Unit'
        },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'OriginalQuotationItem.Quantity'
        },
        {
          text: this.$t('quotation_item_total_quantity'),
          align: 'end',
          value: 'OriginalQuotationItem.TotalQuantity'
        },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    transferOrderNewItemDataTableHeaders () {
      return [
        {
          text: this.$t('transfer_order_add'),
          align: 'start',
          value: 'IsAdd'
        },
        {
          text: this.$t('quotation_item_number'),
          align: 'start',
          value: 'NewQuotationItem.Number'
        },
        {
          text: this.$t('transfer_order_describe'),
          align: 'start',
          value: 'NewQuotationItem.Describe'
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'NewQuotationItem.Name'
        },
        {
          text: this.$t('quotation_item_unit'),
          align: 'start',
          value: 'NewQuotationItem.Unit'
        },
        {
          text: this.$t('quotation_item_quantity'),
          align: 'end',
          value: 'NewQuotationItem.Quantity'
        },
        {
          text: this.$t('quotation_item_total_quantity'),
          align: 'end',
          value: 'NewQuotationItem.TotalQuantity'
        },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    }
  },
  methods: {
    async getTransferOrder () {
      this.isLoadingTransferOrder = true
      let params = {
        CustomerId: this.filterTransferOrder.CustomerId,
        LicensePlate: this.filterTransferOrder.LicensePlate,
        Number: this.filterTransferOrder.Number,
        Status: this.transferOrderStatus.None
      }
      let response = await HttpTransferOrder.GetTransferOrders(params)

      this.transferOrderList = response && response.status === 200 ? response.data.Data : []
      this.isLoadingTransferOrder = false
    },
    isShowTransferOrderDialogBtn (item) {
      this.editedTransferOrderIndex = this.transferOrderList.indexOf(item)
      this.editedTransferOrder = JSON.parse(JSON.stringify(item))
      this.isShowEditedTransferOrderDialog = true
    },
    async closeEditedTransferOrderDialog () {
      this.isShowEditedTransferOrderDialog = false
      this.$nextTick(() => {
        this.editedTransferOrderIndex = -1
        this.editedTransferOrder = JSON.parse(JSON.stringify(this.defaultTransferOrder))
      })
      await this.getTransferOrder()
    },
    async setFilterCustomer (val) {
      this.filterTransferOrder.CustomerId = val.Id
      this.filterTransferOrder = JSON.parse(JSON.stringify(this.filterTransferOrder))
    }
  }
}
</script>
